import React, { useEffect, useState, useRef } from "react";
import Modal from "../../../Modal";
import { Button, FormInput } from "@fastlane-llc/lossexpress-ui-kit";
import { Dropdown } from "primereact/dropdown";
import { addUser as addUserAPI } from "../../../../services/users";
import "./AddUserModal.css";
import { getVendorConnectedCompanies } from "../../../../services/vendors";
import { useForm } from "react-hook-form";

const userRoleOptions = [
  { value: "User", label: "User" },
  { value: "Administrator", label: "Administrator" }
];

const removeEmptyKeys = object => {
  for (const key in object) {
    if (typeof object[key] === "object") {
      removeEmptyKeys(object[key]);
    }
    if (object[key] === null || object[key] === "") {
      delete object[key];
    }
  }
};

const AddUserModal = ({ onClose, setError, setSuccess }) => {
  const [carriers, setCarriers] = useState([]);
  const [selectedUserRole, setSelectedUserRole] = useState(
    userRoleOptions[0].value
  );
  const [selectedCarrier, setSelectedCarrier] = useState(null);

  const formRef = useRef();

  const {
    register,
    handleSubmit,
    setValue,
    errors,
    unregister,
    control
  } = useForm({
    mode: "onBlur"
  });

  useEffect(() => {
    register({ name: "userRole" }, { required: true });
    register({ name: "carrierId" }, { required: true });
  }, [register]);

  useEffect(() => {
    (async function() {
      const carriers = await getVendorConnectedCompanies();
      setCarriers(carriers);

      if (carriers.length === 1) {
        setValue("carrierId", carriers[0].carrierId);
      }
      setSelectedCarrier(carriers[0].carrierId);
    })();
  }, [setValue]);

  useEffect(() => {
    setValue("userRole", userRoleOptions[0].value);
  }, [setValue]);

  const selectRole = () => val => {
    setValue("userRole", val.value);
    setSelectedUserRole(val.value);
  };

  const selectCarrier = () => val => {
    setValue("carrierId", val.value);
    setSelectedCarrier(val.value);
  };

  const onSubmit = async () => {
    const form = formRef.current;
    let data = {};
    if (form) {
      const formData = new FormData(form);
      const values = Object.fromEntries(formData.entries());
      data = values;
    }

    data.userRole = selectedUserRole;
    data.carrierId = selectedCarrier;
    // temp fix to get new order menu over the finish line
    if (
      Object.keys(errors).length > 0 ||
      !data.userRole ||
      !data.carrierId ||
      !data.username ||
      !data.emailAddress ||
      !data.name
    ) {
      return;
    }
    removeEmptyKeys(data);
    try {
      await addUserAPI(
        data.username,
        data.emailAddress,
        data.userRole,
        data.name,
        data.mailingStreetAddress,
        data.mailingCity,
        data.mailingState,
        data.mailingZipCode,
        data.mailingAdditionalInfo,
        data.phoneNumber,
        data.carrierId
      );
      setError("");
      setSuccess(
        `Successfully added user: ${data.name} (${data.emailAddress})`
      );
      closeModal();
    } catch (ex) {
      setError(
        "There was an error saving the user. Please try another username."
      );
      setSuccess("");
      closeModal();
    }
  };

  const closeModal = () => {
    onClose();
  };

  return (
    <Modal style={{ width: "30em" }} onClose={closeModal} title="Add User">
      <form
        ref={formRef}
        onSubmit={handleSubmit(onSubmit)}
        className="FormWrapper"
      >
        <FormInput
          error={errors.name}
          name="name"
          placeholder={"Name (First and Last)"}
          register={register}
          unregister={unregister}
          required
        />
        <FormInput
          error={errors.username}
          name="username"
          placeholder={"Username"}
          register={register}
          unregister={unregister}
          required
        />
        <FormInput
          error={errors.emailAddress}
          name="emailAddress"
          placeholder="Email Address"
          required
          register={register}
          unregister={unregister}
        />
        <FormInput
          name="phoneNumber"
          placeholder="Phone Number"
          error={errors.phoneNumber}
          required
          format="phone"
          control={control}
          formatOnChange
          useFormatPattern
        />
        <Dropdown
          name="userRole"
          options={userRoleOptions}
          placeholder="User Role"
          value={selectedUserRole || userRoleOptions[0].value}
          onChange={selectRole()}
          className="AddUserModal__Dropdown"
          appendTo="self"
        />
        <Dropdown
          name="carrierId"
          options={carriers.map(carrier => ({
            value: carrier.carrierId,
            label: carrier.name
          }))}
          placeholder="Carrier"
          value={selectedCarrier || carriers[0]?.carrierId}
          onChange={selectCarrier()}
          className="AddUserModal__Dropdown"
          appendTo="self"
        />
        <p>
          You can optionally add a specific remittance address for this user if
          your process requires it.
        </p>
        <FormInput
          placeholder="Street Address"
          name="mailingStreetAddress"
          type="text"
          register={register}
          unregister={unregister}
        />
        <FormInput
          placeholder="City"
          name="mailingCity"
          type="text"
          register={register}
          unregister={unregister}
        />
        <FormInput
          placeholder="State"
          name="mailingState"
          type="text"
          register={register}
          unregister={unregister}
        />
        <FormInput
          placeholder="Zip Code"
          name="mailingZipCode"
          type="text"
          register={register}
          unregister={unregister}
        />
        <FormInput
          placeholder="Add'l Remittance Information (Suite, etc.)"
          name="mailingAdditionalInfo"
          type="text"
          register={register}
          unregister={unregister}
        />
        <Button
          onClick={() => {
            onSubmit();
          }}
        >
          Add User
        </Button>
      </form>
    </Modal>
  );
};

export default AddUserModal;
